// ABOUTME: Hook loading the content types and locales a find & replace can search in a hierarchy.
// ABOUTME: Reads GET /api/find-replace/options?hierarchyId=…; only text/html content types are eligible.

import { useEffect, useState } from 'react';

import { getFindReplaceOptions } from '../api/findReplaceApi';
import { FindReplaceOptions } from '../types';

export function useFindReplaceOptions(hierarchyId: string | null) {
    const [options, setOptions] = useState<FindReplaceOptions | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        if (!hierarchyId) return undefined;
        let active = true;
        setLoading(true);
        getFindReplaceOptions(hierarchyId)
            .then(data => {
                if (!active) return;
                setOptions(data);
                setError(null);
            })
            .catch(e => {
                if (active) setError(e instanceof Error ? e : new Error(String(e)));
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, [hierarchyId]);

    return { options, loading, error };
}
